function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
// @ts-ignore
import React, { createContext, useContext, useState } from 'react';
import NoodleModal from "./NoodleModal";
import { _delete } from "noood/net/xhr";
import { NoodleModalTemplates } from "noood/comp/modal/noodle-modal/NoodleModalTemplates";
export var NoodleModalContext = /*#__PURE__*/createContext({});
export default function NoodleModalProvider(props) {
  var _modals$map;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    modals = _useState2[0],
    setModals = _useState2[1]; // we want "stackable" modals, eg, modals on top of modals

  var __success = function __success(content, settings) {
    var newModal = __createModal(content, settings, null);
    setModals([].concat(_toConsumableArray(modals), [newModal]));
  };
  var __confirm = function __confirm(content, settings) {
    var newModal = __createModal(content, _objectSpread(_objectSpread({}, settings), {}, {
      promptType: "CONFIRM"
    }), null);
    setModals([].concat(_toConsumableArray(modals), [newModal]));
  };
  var __createModal = function __createModal(content, settings, index) {
    return /*#__PURE__*/React.createElement(NoodleModal, {
      key: index !== null && index !== void 0 ? index : modals.length,
      content: content,
      settings: settings,
      index: index !== null && index !== void 0 ? index : modals.length
    });
  };
  var __deleteModal = function __deleteModal(idx) {};
  var __load = function __load(content, settings) {
    var newModal = __createModal(content, settings, null);
    setModals([].concat(_toConsumableArray(modals), [newModal]));
  };
  var __replace = function __replace(index, content, settings) {
    var modalsClone = _toConsumableArray(modals);
    modalsClone[index] = __createModal(content, settings, index);
    setModals(modalsClone);
  };
  var __confirmDelete = function __confirmDelete(_ref) {
    var entity = _ref.entity,
      endpoint = _ref.endpoint,
      __onAfterDelete = _ref.__onAfterDelete;
    var thisIndex = modals.length;
    var modal = /*#__PURE__*/React.createElement(NoodleModal, {
      key: "modal-".concat(thisIndex),
      content: "Are you sure you want to delete this ".concat(entity === null || entity === void 0 ? void 0 : entity.toLowerCase(), "?"),
      index: thisIndex,
      settings: {
        title: "Delete ".concat(entity),
        primary: _objectSpread(_objectSpread({}, NoodleModalTemplates.button["delete"]), {}, {
          __do: function __do(idx, operations) {
            operations.setIsProcessing(true);
            _delete(endpoint, function (response) {
              operations.setIsProcessing(false);
              operations.onAfterDo(response, function () {
                __onAfterDelete === null || __onAfterDelete === void 0 || __onAfterDelete(response);
              }, {
                primary: {
                  label: "OK",
                  icon: "check",
                  nature: "neutral"
                }
              });
            });
          }
        }),
        secondary: {}
      }
    });
    setModals([].concat(_toConsumableArray(modals !== null && modals !== void 0 ? modals : []), [modal]));
  };

  /**
   * @param idx the zero-based index of the list of modals (as they can be stacked)
   * in most cases, this will just remove the end of the array
   */
  var __closeModal = function __closeModal(idx) {
    var modalsClone = _toConsumableArray(modals);
    modalsClone.splice(idx, 1);
    setModals(modalsClone);
  };
  var contextStore = {
    __success: __success,
    __confirm: __confirm,
    __closeModal: __closeModal,
    __replace: __replace,
    __load: __load,
    __confirmDelete: __confirmDelete
  };
  return /*#__PURE__*/React.createElement(NoodleModalContext.Provider, {
    value: contextStore
  }, (modals === null || modals === void 0 ? void 0 : modals.length) > 0 && ((_modals$map = modals.map) === null || _modals$map === void 0 ? void 0 : _modals$map.call(modals, function (modal, idx) {
    return modal;
  })), props.children);
}
export var useModalContext = function useModalContext() {
  var context = useContext(NoodleModalContext);
  if (context === undefined) {
    throw new Error('useModalContext must be used within a NoodleModalProvider');
  }
  return context;
};